import { Component, inject, signal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { CompanyReportModalComponent } from '../company-report-modal/company-report-modal.component';
import { PackLimitationsService } from 'src/app/shared/services/pack-limitations.service';
import { LockedButtonComponent } from 'src/app/shared/components/locked-button/locked-button.component';
import { LimitedFeatures } from 'src/app/shared/models/pack.models';

@Component({
  selector: 'app-export-company-report-to-pdf',
  standalone: true,
  imports: [
    ButtonModule,
    TranslocoPipe,
    CompanyReportModalComponent,
    LockedButtonComponent,
  ],
  templateUrl: './export-company-report-to-pdf.component.html',
})
export class ExportCompanyReportToPdfComponent {
  protected packLimitationService = inject(PackLimitationsService);
  protected showModal = signal(false);
  protected canExportPDF = this.packLimitationService.canExportPDF;
  protected pdfFeature = LimitedFeatures.Pdf;
}
